import BookLibraryAdapter from 'teacher-ui-client/adapters/book-library'

export default class BookLibraryBookMetadataAdapter extends BookLibraryAdapter {}
